import React from 'react';
import { Box, Typography, Grid } from '@mui/joy';
import MetricCard from './MetricCard';

const SurveyAnalytics = ({ surveyProjects }) => {
  // Calculate metrics
  const totalProjects = surveyProjects.length;

  // New metrics for status
  const statusCounts = {
    'Not Started': surveyProjects.filter(p => (p.status || 'Not Started') === 'Not Started').length,
    'In Progress': surveyProjects.filter(p => p.status === 'In Progress').length,
    'Delivered': surveyProjects.filter(p => p.status === 'Delivered').length,
    'Complete': surveyProjects.filter(p => p.status === 'Complete').length,
    'On Hold': surveyProjects.filter(p => p.status === 'On Hold').length,
  };

  // Priority metrics
  const highPriorityProjects = surveyProjects.filter(p => p.priority === 1).length;

  // In progress + overdue projects (critical metric)
  const activeOverdueProjects = surveyProjects.filter(p => 
    (p.status === 'In Progress' || p.status === 'Not Started') && 
    p.due_date && new Date(p.due_date) < new Date()
  ).length;

  const getGradientColors = (type) => {
    switch (type) {
      case 'total':
        return ['#2e7d32', '#1b5e20'];
      case 'inProgress':
        return ['#ed6c02', '#e65100'];
      case 'highPriority':
        return ['#d32f2f', '#b71c1c'];
      case 'activeOverdue':
        return ['#dc2626', '#7f1d1d'];
      default:
        return ['#2e7d32', '#1b5e20'];
    }
  };

  const getIcon = (type) => {
    switch (type) {
      case 'total':
        return 'engineering';
      case 'inProgress':
        return 'pending';
      case 'highPriority':
        return 'priority_high';
      case 'activeOverdue':
        return 'warning';
      default:
        return 'engineering';
    }
  };

  return (
    <Box sx={{ mb: 4 }}>
      <Typography 
        level="h3" 
        sx={{ 
          mb: 3, 
          color: 'success.700',
          display: 'flex',
          alignItems: 'center',
          gap: 2
        }}
        className="fade-in"
      >
        <span className="material-symbols-outlined" style={{ fontSize: '32px', fontFamily: 'Material Symbols Outlined' }}>
          analytics
        </span>
        Survey Analytics
      </Typography>
      
      <Grid container spacing={3} className="fade-in-up">
        {/* Core Metrics */}
        <Grid xs={12} sm={6} md={3}>
          <MetricCard
            title="Total Projects"
            value={totalProjects}
            icon={getIcon('total')}
            gradientColors={getGradientColors('total')}
          />
        </Grid>
        <Grid xs={12} sm={6} md={3}>
          <MetricCard
            title="In Progress"
            value={statusCounts['In Progress']}
            icon={getIcon('inProgress')}
            gradientColors={getGradientColors('inProgress')}
          />
        </Grid>
        <Grid xs={12} sm={6} md={3}>
          <MetricCard
            title="Overdue Projects"
            value={activeOverdueProjects}
            icon={getIcon('activeOverdue')}
            gradientColors={getGradientColors('activeOverdue')}
          />
        </Grid>
        <Grid xs={12} sm={6} md={3}>
          <MetricCard
            title="High Priority"
            value={highPriorityProjects}
            icon={getIcon('highPriority')}
            gradientColors={getGradientColors('highPriority')}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default SurveyAnalytics;